export default "__VITE_ASSET__DaURe4ND__"